import classNames from "classnames";
import CheckIcon from "../../assets/icons/CheckIcon";
import { businessInitials, userColor } from "../../utils/userUtils";
import './BusinessSelector.scss';

export default function BusinessSelector({ businesses, disabled, role, onChange }) {
  return (
    <div className={classNames('__business-selector', { '__business-selector-disabled': disabled })}>
      <h3>Businesses</h3>
      { businesses.map(business => (
        <button disabled={disabled} key={business.id} className={classNames('business-toggle', { selected: role.business_ids.includes(business.id) })} onClick={() => onChange(business.id, !role.business_ids.includes(business.id))}>
          <div className={classNames('check-container', { checked: role.business_ids.includes(business.id) })}><CheckIcon /></div>
          <div className="business-logo" style={{ backgroundColor: userColor(business).code }}><span>{ businessInitials(business.name) }</span></div>
          <div className='category-label'>{ business.name }</div>
        </button>
      ))}
      { businesses.length === 0 && (
        <div className='empty-business'>This organization has no businesses</div>
      )}
    </div>
  );
}
